import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import React from 'react';
import { forgotPasswordSendEmail, login, register } from '../../api';
import {
  handleApiGlobalError,
  handleGlobalApiCalls,
} from '../../helpers/asyncActions';
import CloseIcon from '../../images/close.svg';
/* import FacebookLogo from '../../images/facebook.svg'; */
import GoogleLogo from '../../images/google.svg';
import LogoWhite from '../../images/logo-blanco.svg';
import { useGlobalContext } from '../../stores/global';
import FormButton from '../Form/FormButton';
import styles from './Login.module.scss';
import LoginForgetPassword from './LoginForgetPassword';
import LoginSignin from './LoginSignin';
import LoginSignup from './LoginSignup';

export default function Login() {
  const { isLoading, loginModal, dispatch } = useGlobalContext();

  const handleFormSubmit = async (type: 'signin' | 'signup', data: any) => {
    dispatch({ type: 'SET_LOADING', payload: true });

    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      (type === 'signin' ? login(data) : register(data))
        .then((response) => {
          const { user, session } = response;

          dispatch({
            type: 'SET_USER',
            payload: {
              id: user.id,
              name: user.name,
              email: user.email,
              token: session.token,
              ...user,
            },
          });

          window.location.reload();
        })
        .catch((err) => {
          dispatch({ type: 'SET_USER', payload: undefined });
          throw err;
        })
    );
  };

  const handleForgetPasswordSubmit = (data: any) => {
    if (!data?.email) return;

    if (isLoading) return;

    dispatch({ type: 'SET_LOADING', payload: true });

    forgotPasswordSendEmail(data.email)
      .then(() => {
        dispatch({ type: 'SET_LOGIN_MODAL', payload: undefined });
        dispatch({
          type: 'SET_ALERT_MODAL',
          payload: {
            title: 'Correo enviado',
            message:
              'Te hemos enviado un correo electrónico para que puedas restablecer tu contraseña',
          },
        });
      })
      .catch(handleApiGlobalError.bind(null, dispatch))
      .finally(() => dispatch({ type: 'SET_LOADING', payload: false }));
  };

  const handleClose = () => {
    dispatch({ type: 'SET_LOGIN_MODAL', payload: undefined });
  };

  return (
    <Modal
      hideBackdrop
      open={!!loginModal}
      className={styles.container}
      onClose={handleClose}
    >
      <div className={styles.wrapper}>
        <ClickAwayListener onClickAway={handleClose}>
          <div className={styles.containerContent}>
            <div className={styles.content}>
              <img className={styles.headerlogo} src={LogoWhite} />

              <div className={styles.close}>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  size="large"
                >
                  <img src={CloseIcon} />
                </IconButton>
              </div>

              <div className={styles.tabs}>
                <button
                  className={loginModal === 'signin' ? styles.tabsActive : ''}
                  onClick={() =>
                    dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' })
                  }
                >
                  Entrar
                </button>
                <button
                  className={loginModal === 'signup' ? styles.tabsActive : ''}
                  onClick={() =>
                    dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signup' })
                  }
                >
                  Registrarse
                </button>
              </div>

              {loginModal === 'signin' && (
                <LoginSignin
                  onForgetPassClick={() =>
                    dispatch({
                      type: 'SET_LOGIN_MODAL',
                      payload: 'forgetPassword',
                    })
                  }
                  onSubmit={(data) => handleFormSubmit('signin', data)}
                />
              )}

              {loginModal === 'signup' && (
                <LoginSignup
                  onSubmit={(data) => handleFormSubmit('signup', data)}
                />
              )}

              {loginModal === 'forgetPassword' && (
                <LoginForgetPassword onSubmit={handleForgetPasswordSubmit} />
              )}

              {/*               <FormButton
                fullWidth
                variant="outlined"
                startIcon={<img src={FacebookLogo} />}
                onClick={() => {
                  window.location.href =
                    'https://api.hauscanner.com/v1/auth/facebook';
                }}
              >
                Entrar con Facebook
              </FormButton> */}
              <FormButton
                fullWidth
                variant="outlined"
                startIcon={<img src={GoogleLogo} />}
                onClick={() => {
                  window.location.href =
                    'https://api.hauscanner.com/v1/auth/google';
                }}
              >
                Entrar con Google
              </FormButton>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
}
